import { render, staticRenderFns } from "./JOLTC.vue?vue&type=template&id=51860ae6&scoped=true"
import script from "./JOLTC.vue?vue&type=script&lang=ts"
export * from "./JOLTC.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51860ae6",
  null
  
)

export default component.exports